import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-schedule-success',
  templateUrl: './schedule-success.component.html',
  styleUrls: ['./schedule-success.component.scss']
})
export class ScheduleSuccessComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ScheduleSuccessComponent>,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
